import React from 'react'
import Banner from '../components/Banner'
import { Helmet } from "react-helmet-async";

const About = () => {
  return (
    <>
    <Helmet>
            <title>
              Yacht Rental & Boat Charters in Dubai Marina | BlueHarbour
            </title>
            <meta
              name="keywords"
              content="Yacht rental dubai, Dubai yacht rental, Yacht rental dubai marina, Yachts rental dubai, Luxury yacht rental dubai, Yachts rental dubai price, Yacht rentals in dubai, Dubai yacht rentals, Party yacht rental dubai, Small yacht rental dubai, Private yacht rental dubai, Dubai yacht rental prices, Luxury yacht rental in dubai, Birthday yacht rental dubai, Yacht rental dubai for birthday, Yacht rental dubai new year’s eve, Yacht rental dubai party, Yacht rental in dubai prices, Best yacht rental dubai, Dubai marina yacht rental, Yacht rental marina dubai price, Dubai luxury yacht rental, Yacht rental dubai for couples, Luxury yacht rental dubai marina"
            />
            <meta name="description" content="Learn about BlueHarbour, Dubai’s trusted yacht rental provider offering luxury yachts, private boat charters, and unforgettable experiences on the water.
" />
          </Helmet>

            <main id="about">

      <Banner img="assets/yachtimages/about-banner.webp" text="BlueHarbour – Your Trusted Partner for Yacht Rentals in Dubai" />
      <section className="section-2 gap">
        <div className="container">
          <div className="row gx-5">
            <div className="col-lg-5 my-auto">
              <div>
                <h2 className="text-blue fw-bold mb-3">Luxury Yacht Rental in Dubai – Welcome to Blue Harbour
                </h2>
                <p>
                Welcome Aboard! </p>
                <p>
At Blue Harbour, we offer more than just a yacht—we create unforgettable experiences on the water. Anchored in the prestigious Dubai Marina, we specialize in giving unparalleled yacht experience for those who seek comfort, elegance, and adventure.
</p>
<p>
Whether you're looking for a private yacht rental Dubai style, planning a birthday celebration, or hosting a special event, our fleet has something for everyone.
</p>
<p>
From small yacht rentals for intimate gatherings to party yacht rentals for lively occasions, each cruise is tailored to your needs with professional crew, top-tier service, and stunning views.
</p>
<p>
As one of the top-rated providers of Dubai yacht rentals, Blue Harbour is your trusted partner for making memories—whether it’s a sunset cruise, a weekend getaway, or a New Year’s Eve celebration at sea. With us, your journey is more than a ride—it’s a luxury experience crafted to perfection.

                </p>

              </div>
            </div>
            <div className="col-lg-7" id="two_column_absection">
              <div className="image-container d-flex justify-content-end">
                <img src="assets/yachtimages/about-img.webp" alt="" />
                <div className="side-image">
                  <img src="assets/yachtimages/square-img.webp" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-3 gap">
        <div className="bg-color">
          <div className="container">
            <h2>
            Sail, Celebrate, Enjoy- Experience luxury on the waters with Blue Harbour luxury yacht rental in Dubai.
            </h2>
          </div>
          <div className="row gx-5 mt-lg-5 mt-3">

            <div className="col-md-4">
              <div className="overlay-container">
                <img src="assets/yachtimages/celebrate.webp" className="image" />
                <div className="overlay overlay-cross">
                  <div className="icon">
                    <i className="fa-solid fa-arrows-up-down-left-right"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="image-wrapper">
                <img src="assets/yachtimages/celebrate2.webp"
                  alt="" />
              </div>
            </div>
            <div className="col-md-4">
              <div className="image-wrapper">
                <img src="assets/yachtimages/celebrate3.webp"
                  alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why-section gap">
        <div className="container">
          <h4 className="text-center text-blue fw-bold">Our</h4>
          <h2 className="text-center text-blue fw-bold">Mission & Vision</h2>
          <div className="row gx-5 mt-5">

            <div className="col-lg-12">
              <div className="row gx-5">
                <div className="col-md-6 mb-4 h-auto">

                  <div className="boxshadow p-3 h-100">
                    <h4 className="mb-4 text-blue">
                      <b>
                        Our Mission
                      </b>
                    </h4>

                    <p>
                    To create unforgettable memories through smooth, stylish, and personalized yacht rental experiences in Dubai. Whether it’s a birthday celebration, a romantic escape, or a gathering with friends, we’re here to turn every moment on the water into something truly special—with comfort, class, and care in every detail.

                    </p>
                  </div>
                </div>

                <div className="col-md-6 mb-4 h-auto">
                  <div className="boxshadow p-3 h-100">
                    <h4 className="mb-4 text-blue">
                      <b>
                        Our Vision
                      </b>
                    </h4>

                    <p>
                    To become Dubai’s most loved name in luxury yacht rentals, known not just for our premium yachts, but for the experiences we create. We aim to bring people together, celebrate life’s best moments, and redefine what it means to sail in style—one breathtaking cruise at a time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="quality gap">
        <div className="container">
          <div className="row gx-5">

            <div className="col-lg-12">
              <div>
                <h2 className="text-blue fw-bold">Why Blue Harbour is Your Perfect Choice for Luxury Yacht Rental in Dubai
                </h2>
                <br />
                <ul>
                  <li>
                    <p>
                    At Blue Harbour, we don’t just provide yacht rentals in Dubai—we craft experiences that stay with you forever.
                    </p>
                  </li>
                  <li>
                    <p>
Prime Location at Dubai Marina: Conveniently situated at the heart of the city’s iconic Dubai Marina, we offer stunning views of the city skyline and calm, pristine waters. It’s the perfect spot to start your unforgettable journey.
</p>
                  </li>
                  <li>
                    <p>
Tailored Fleet for Every Occasion: Whether you’re looking for a cozy small yacht rental in Dubai for an intimate escape or a grand party yacht rental for a celebration with friends, our diverse fleet caters to every need and group size.
</p>
                  </li>
                  <li>
                    <p>
Exceptional Service: Our dedicated crew ensures your experience is seamless, from the moment you step on board to when the journey ends. With Blue Harbour, your comfort, safety, and enjoyment are our top priorities.
</p>
                  </li>
                  <li>
                    <p>
Unmatched Luxury: We offer only the finest yachts, equipped with state-of-the-art amenities, stylish interiors, and a range of services that elevate your experience—whether it’s a sunset cruise or a festive party.
</p>
                  </li>
                  <li>
                    <p>
Competitive and Transparent Pricing: We believe in clear, fair pricing for our yacht rentals in Dubai, with flexible packages designed to meet your budget without compromising on quality.
</p>
                  </li>
                  <li>
                    <p>
Memorable Experiences on the Water: At Blue Harbour, we specialize in creating moments that last—a perfect evening for couples, a birthday yacht rental in Dubai with friends, or a special getaway for a family. We make sure every detail reflects luxury and personal care.
</p>
                  </li>
                  <li>
                    <p>

With Blue Harbour, your next adventure on the water is set to be extraordinary. We’re here to provide the luxury you deserve, turning every moment into a memory you’ll cherish forever.

                    </p>
                  </li>

                </ul>
              </div>
            </div>
            <div className="col-lg-12 mt-4" >
              <div className="image-container justify-content-end">
                <img src="assets/yachtimages/why.webp" alt="" style={{ width: "100%", height: "auto" }} />

              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>

  )
}

export default About